import React from 'react';
import { Carousel } from 'react-bootstrap';
import duman1 from '../assets/main_m.png';
import duman2 from '../assets/main_m2.png';
import duman3 from '../assets/main_m3.png';
import duman4 from '../assets/main_m4.png';
import dumanMain from '../assets/main_m5.png';

const NewMainDumanM = () => {
	return (
		<>
			<Carousel fade>
				<Carousel.Item>
					<div className='m_duman_box'>
						<div className='m_duman_image_box'>
							<img src={dumanMain} alt='logo' />
						</div>
					</div>
				</Carousel.Item>
				<Carousel.Item>
					<div className='m_duman_box'>
						<div className='m_duman_image_box'>
							<img src={duman1} alt='logo' />
						</div>
					</div>
				</Carousel.Item>
				<Carousel.Item>
					<div className='m_duman_box'>
						<div className='m_duman_image_box'>
							<img src={duman2} alt='logo' />
						</div>
					</div>
				</Carousel.Item>
				<Carousel.Item>
					<div className='m_duman_box'>
						<div className='m_duman_image_box'>
							<img src={duman3} alt='logo' />
						</div>
					</div>
				</Carousel.Item>
				<Carousel.Item>
					<div className='m_duman_box'>
						<div className='m_duman_image_box'>
							<img src={duman4} alt='logo' />
						</div>
					</div>
				</Carousel.Item>
			</Carousel>
		</>
	);
};

export default NewMainDumanM;
